var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[(_vm.displayTarget === 'A')?_c('span',[_vm._v("모두")]):_vm._e(),(_vm.displayTarget === 'P')?_c('span',[_vm._v("PC")]):_vm._e(),(_vm.displayTarget === 'M')?_c('span',[_vm._v("모바일")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }